import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { NewsComponent } from './news/news.component';
import { NewsPR1Component } from './news/pr1.component';
import { NewsPR2Component } from './news/pr2.component';
import { Pr3Component } from './news/pr3.component';
import { Pr4Component } from './news/pr4.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'news', component: NewsComponent },
  { path: 'news/pr1', component: NewsPR1Component },
  { path: 'news/pr2', component: NewsPR2Component },
  { path: 'news/pr3', component: Pr3Component },
  { path: 'news/pr4', component: Pr4Component },
  // Optionally, add a generic route for future news items:
  // { path: 'news/:id', component: NewsDetailComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
